import { Box } from "@mui/system"
import { useState, useEffect } from "react"
import { CSVLink } from "react-csv";

export default function CSVReport({searchResult,  domain}) {

    const [table, setTable] = useState([])
    const [domainResult, setDomainResult] = useState([])

    useEffect(()=> {

      let  data = []

        for (const item of searchResult) {
                let obj = {}
                const index = item[7]
                obj['plain'] = item[0]
                obj['source'] = item[1]
                obj['translation'] = item[5]
                obj['token'] = item[2][index]
                obj['lemma'] = item[3][index]
                obj['annotation'] = item[4][index]
                obj['UD'] = item[6][index]
                data.push(obj)
        }

        setTable(data)
        setDomainResult(domain)


    }, [searchResult, domain]);


    let headers = [
        {label:'Plain text', key: 'plain'},
        {label:'Source', key: 'source'},
        {label:'Translation', key: 'translation'},
    ];


    if (domainResult !== 'full') {

         headers = [
            {label:'Plain text', key: 'plain'},
            {label:'Source', key: 'source'},
            {label:'Token', key: 'token'},
            {label:'Lemma', key: 'lemma'},
            {label:'Annotation', key: 'annotation'},
            {label:'UD', key: 'UD'},
            {label:'Translation', key: 'translation'},
        ];
    } 
    

    const csvFile = {
            filename: 'Result.csv',
            headers: headers,
            data: table
    };

    return(

        <>
        {(searchResult.length >= 1) ?
                <Box mt={2}>

                    <CSVLink  {...csvFile}> Download CSV </CSVLink>

                </Box> : null  }

        </>

    )



}